import React from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import CartTable from './CartTable';

const CartContainer = () => {
  return (
    <>
      <Container fluid={true} className='product-wrapper'>
        <Breadcrumbs justify='end' pageTitle='Cart' parent='Ecommerce' title='Cart' />
        <Row>
          <CartTable />
        </Row>
      </Container>
    </>
  );
};

export default CartContainer;
